import React, { Component } from 'react';
import '../assets/custom.css';
import REST from '../Shared/REST';
import { withRouter } from 'react-router-dom';
import LeveledChartComponent from '../Shared/Chart/Chart';
import Helpers from "../Shared/Helpers";
import HeaderComponent from '../Shared/Header';
import {connect} from "react-redux";
import {prepareChartData} from "./actions";
// import { LineChart, Line, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from 'recharts';
let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;

class StudentDataComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            updateNote:null,
            appName:"appName",
            student:this.props.student,
            PNModel:this.props.PNModel
        };
    }

    componentDidMount() {
        Helpers.authorize(this);

        switch (this.props.type) {
            case 1:
                this.listMazeData();
                break;
            case 2:
                this.listSlashTestData();
                break;
            case 3:
                this.listWordMarkData();
                break;
            case 4:
                this.listKidSpeakData();
                break;
            case 5:
                this.listPictureNamingData();
                break;
            case 6:
                this.listCopyRightData();
                break;
            case 7:
                this.listWordSignSayData();
                break;
            case 8:
                this.listKidSignData();
                break;
            case 9:
                this.listWordMark2Data();
                break;
            default:
                break;
        }
    }

    async listMazeData() {
        await REST.listMazeScoreData(this.props.student.userId).then(async(response) => {
            console.log('Response', response.body);
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateMazeNote,
                    appName:"Maze"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:false,
                        isTeacher:true,
                        macroLevelGrowth: 26 //move up a level every 18 weeks
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listSlashTestData() {
        await REST.listSlashTestScoreData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateSlashNote,
                    appName:"Slash"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:false,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listKidSpeakData() {
        await REST.listKidSpeakScoreData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateKidSpeakNote,
                    appName:"KidSpeak"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:false,
                        isTeacher:true,
                        macroLevelGrowth: 26
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listPictureNamingData() {
        await REST.listPictureNamingData(this.props.student.userId, this.state.PNModel).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                let data = response.body;
                await this.setState({
                    data: response.body,
                    updateNote:REST.updatePNNote,
                    appName:"Picture Naming"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
                        maxLevel:3,
                        showScore:true,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Speed",
                    PNModel: this.state.PNModel
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listCopyRightData() {
        await REST.listCopyRightData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateCopyRightNote,
                    appName:"CopyRight"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:false,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listKidSignData() {
        await REST.listKidSignData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateKidSignNote,
                    appName:"KidSign"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:false,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listWordSignSayData() {
        await REST.listWordSignSayData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                let data = response.body;
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateWordSignSayNote,
                    appName:"Word Sign/Say"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
                        maxLevel:12,
                        showScore:true,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Speed"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }

    async listWordMarkData() {
        await REST.listWorkMarkScoreData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateWordMarkNote,
                    appName:"WordMark"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[2,2],
                        maxLevel:2,
                        showScore:true,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }
    async listWordMark2Data() {
        await REST.listWorkMark2ScoreData(this.props.student.userId).then(async(response) => {
            if (response.success) {
                if(response.body && response.body.length===0){
                    return this.props.history.push("/");
                }
                await this.setState({
                    data: response.body,
                    updateNote:REST.updateWordMark2Note,
                    appName:"WordMark2"
                });
                await this.props.updateChartData({
                    ...this.state,
                    chartData:this.state.data,
                    chartRules:{
                        growthRate:[2,2],
                        maxLevel:2,
                        showScore:true,
                        isTeacher:true
                    },
                    xLabel:"Weeks",
                    yLabel:"Highest Level Reached"
                });
            }
            else {
                alert('Error fetching data: ' + response.msg);
            }
        }, (error) => {
            console.log('Error', error);
        });
    }
    handleLogout = async () => {
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                this.props.history.push("/");
    };

    render() {
        if(this.props.chartData && this.props.chartData.length>0 && this.state.appName===this.props.appName) {
            return (
                <div className="container-fluid chartLoader1 hidden" style={{paddingLeft:0,paddingRight:0,background:'#f2f2f2'}}>
                    {/*<div>{this.state.data.length} results</div>*/}
                    <div className={"container-fluid"} style={{background:'#fff'}}>
                        <HeaderComponent dataCharts appName={this.props.appName} PNModel={this.props.PNModel} imageSrc sName={this.props.student} logout={this.handleLogout} />
                    </div>
                    <LeveledChartComponent
                        appName={this.props.appName}
                        student={this.props.student}
                        globalData={this.props.chartData}
                        updateNote={this.props.updateNote}
                        max={20}
                        chartRules={this.props.chartRules}
                        xLabel={this.props.xLabel}
                        yLabel={this.props.yLabel}
                        PNModel = {this.props.PNModel}
                        teacher = {this.props.teacher}
                    />
                </div>
            )
        }
        return null;
    }
}

const bindActionsToProps = dispatch => {
    return {
        updateChartData: async(state) => await dispatch(prepareChartData(state))
    };
};


const mapStateToProps = state => ({
    chartData: state.teacherReducer.chartData,
    chartRules:state.teacherReducer.chartRules,
    xLabel:state.teacherReducer.xLabel,
    yLabel:state.teacherReducer.yLabel,
    updateNote: state.teacherReducer.updateNote,
    appName: state.teacherReducer.appName,
    student: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher
});

export default withRouter(connect(mapStateToProps,bindActionsToProps)(StudentDataComponent));



// WEBPACK FOOTER //
// ./src/TeachersComponent/StudentData.js